var LoggerInstance = require("js-logger").get("Tracker");

var sendTracking = function (eventData, isSessionData) {
	var client = new XMLHttpRequest();
	client.open("POST", "/api/eventtracking/sessiondata", true); // third parameter indicates sync xhr
	client.setRequestHeader("Content-Type", "application/json");
	client.send(JSON.stringify(eventData));
}

module.exports = {
	soTrackPageData: function (pageData) {
		pageData = pageData || {};
		pageData.layoutId = layoutId;

		sendTracking(pageData);
	},

	soTrackSessionData: function (sessionData) {
		sendTracking(sessionData, true);
	},

};
